import React from 'react';
import { Icon } from '@doxyme/ui';
import './ParticipantPublisherErrorFull.scss';
const ParticipantPublisherErrorFull = ({ message, children }) => (<div className="react-pp-error-full">
    <div className="react-pp-error-full__content">
      <Icon name="call-video-off" className="react-pp-error-full__icon" size="small"/>
      <div className="react-pp-error-full__message" data-dd-privacy="mask">{message}</div>
      {children ? (<div className="react-pp-error-full__footnote">{children}</div>) : null}
    </div>
  </div>);
export default ParticipantPublisherErrorFull;
